import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import TextArea from '@containers/text/layout-01'
import BeiratArea from '@containers/beirat'

const NachhaltigkeitsbeiratPage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <TextArea
          data={{
            ...content['einleitung-section']
          }}
        />
        <BeiratArea
          data={{
            ...content['beirat-section']
          }}
          bg="white"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query NachhaltigkeitsbeiratPageQuery($title: String, $locale: String) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default NachhaltigkeitsbeiratPage
